import React from "react";
import { Form, Label, FormGroup } from "reactstrap";
import PropTypes from "prop-types";
import { FormField, CheckFormField, SelectFormField } from "../../../../../utils/FormFields";

const InstructionsTab = ({ account, changedAccount, showChanges }) => {
  const editInstruction = changedAccount.Instructions[0];
  let compareInstruction;
  if  (account.Instructions){
  account.Instructions.map((h) => {
    if (
      (h.AccountInstructionType) == (editInstruction.AccountInstructionType) &&
      h.AccountInstructionsCurrency == editInstruction.AccountInstructionsCurrency
    ) {
      compareInstruction = h;
    }
    return {};
  })
}
  let color = "black";
  if (showChanges) {
    if (compareInstruction && editInstruction.DeleteInstruction) {
      color = "red";
    } else if (compareInstruction) {
      color = "#36a9e1";
    } else {
      color = "green";
    }
  }
  return (
    <Form>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "20px",
          display: "block",
          color,
        }}
      >
        {showChanges ? (
          <React.Fragment>
            {compareInstruction ? (
              <React.Fragment>
                {editInstruction.DeleteInstruction ? "Remove Instruction" : "Edit Instruction"}
              </React.Fragment>
            ) : (
              "New Instruction"
            )}
          </React.Fragment>
        ) : (
          "Actual Account"
        )}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          {!editInstruction.DeleteInstruction && (
            <FormToShow Instruction={editInstruction} refInstruction={compareInstruction} />
          )}
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          {compareInstruction && (
            <FormToShow Instruction={compareInstruction} refInstruction={editInstruction} />
          )}
        </FormGroup>
      )}
    </Form>
  );
};

export default InstructionsTab;

const FormToShow = ({ Instruction, refInstruction }) => (
  <React.Fragment>
    <FormField
      name="AccountInstructionsCurrency"
      value={Instruction.AccountInstructionCurrencyISO}
      disabled={true}
      label="Currency"
      changedColor={
        refInstruction &&
        Instruction.AccountInstructionCurrencyISO !== refInstruction.AccountInstructionCurrencyISO
      }
    />
    <FormField
      name="AccountInstructionType"
      value={Instruction.AccountInstructionType}
      disabled={true}
      label="Instruction Type"
      changedColor={
        refInstruction && Instruction.AccountInstructionType !== refInstruction.AccountInstructionType
      }
    />
    <SelectFormField
      label="Instruction Target: "
      changedColor={
        refInstruction && Instruction.AccountInstructionTarget !== refInstruction.AccountInstructionTarget
      }
      value={Instruction.AccountInstructionTarget}
      selectItems={["Reinvest", "Withdraw"]}
      getSelectItemId={(i) => i}
      getSelectItemName={(i) => i}
      disabled
      name="AccountInstructionTarget"
    />

    {Instruction.AccountInstructionTarget=="Reinvest"?
    (    <FormField
        name="AccountInstructionAssetticker"
        value={Instruction.AccountInstructionAssetticker}
        label="Asset"
        changedColor={
          refInstruction && Instruction.AccountInstructionAssetticker !== refInstruction.AccountInstructionAssetticker
        }
      />

    ):(
        <FormField
        name="AccountInstructionBankAccountName"
        value={Instruction.AccountInstructionBankAccountName}
        label="Bank Account"
        changedColor={
          refInstruction && Instruction.AccountInstructionBankAccountName !== refInstruction.AccountInstructionBankAccountName
        }
      />
    )}

    <FormField
      name="AccountInstructionMin"
      value={Instruction.AccountInstructionMin}
      label="Min"
      changedColor={
        refInstruction && Instruction.AccountInstructionMin !== refInstruction.AccountInstructionMin
      }
    />

<FormField
      name="AccountInstructionMax"
      value={Instruction.AccountInstructionMax}
      label="Max"
      changedColor={
        refInstruction && Instruction.AccountInstructionMax !== refInstruction.AccountInstructionMax
      }
    />


  </React.Fragment>
);

// FormToShow.propTypes = {
//   holder: PropTypes.object.isRequired,
//   isPhysical: PropTypes.bool.isRequired,
//   refHolder: PropTypes.object
// };

// FormToShow.defaultProps = {
//   refHolder: undefined
// };
